<template>
  <div>
    <div class="layout-row layout-align-center-start">
      <v-text-field
        :name="name"
        :key="keyValue"
        :autofocus="autoFocus"
        :focused="autoFocus"
        class="flex ma-0"
        outlined
        :append-icon="disabled ? '' : 'date_range'"
        :color="compColor.textInput"
        :dark="compColor.isInDarkMode"
        :background-color="backgroundColor"
        :label="label"
        :placeholder="placeholder"
        :hint="hint"
        :persistent-hint="persistent_hint"
        ref="input"
        v-model="internalModel"
        @click:append.stop="openDialog"
        @change="$emit('change')"
        @blur="updateValue"
        :required="required"
        :hide-details="hideDetails"
        :disabled="disabled"
        :dense="dense"
        :error-messages="getErrorMsg">
      </v-text-field>

      <v-dialog v-model="dialog" max-width="290">
        <v-card class="transparent">
          <div id="square" style="max-width: 469px;width: 469px;min-width: 469px;min-height: 300px;border:3px solid;"
               class="layout-column pa-0"
               :style="{'border-color': compColor.lxExpansion.background,background: compColor.lxExpansion.background}">
            <div class="flex-30 layout-row py-2 px-4 white--text text--darken-2 white"
                 v-bind:class="[compColor.textInput]" @mousedown="dragThatThing" @mouseup="leftThatThing"
                 title="Drag Window">
              <v-icon small>drag_indicator</v-icon>
              <div class="flex layout-row layout-align-center-center" style="cursor: pointer;position:relative;">
                <span style="font-weight: 300;font-size: 22px;" class="mr-1">{{ getPopupValues.today | formatDate('dddd') }},</span>
                <span style="font-weight: 900;font-size: 25px;" class="ml-1">{{ getPopupValues.today | formatDate('DD. MMMM YYYY') }}</span>
              </div>
              <v-icon small>drag_indicator</v-icon>
            </div>
            <v-divider class="ma-0 mt-1"></v-divider>

            <div class="layout-row pa-1">
              <v-btn depressed class="flex blue-grey mr-1 py-2 text-none caption"
                     :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                     @click="lastDay">Gestern
              </v-btn>
              <v-btn depressed class="flex blue-grey mr-1 py-2 text-none caption"
                     :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                     @click="thisDay">Heute
              </v-btn>
              <v-btn depressed class="flex blue-grey py-2 text-none caption"
                     :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                     @click="nextDay">Morgen
              </v-btn>
            </div>

            <v-divider class="ma-0"></v-divider>


            <div style="height: 250px;" class="px-1 py-1 flex layout-row blue-grey--text">


              <div class="layout-column">
                <div class="layout-row">
                  <v-btn class="flex blue-grey elevation-0 pa-0"
                         :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}" dense
                         @click="nextWeek(-1)" style="height:auto;">
                    <v-icon>mdi-chevron-up</v-icon>
                  </v-btn>
                </div>
                <div class="flex layout-column layout-align-center-center my-2">
                  <table style="margin: 0 0 4px 0;">
                    <thead>
                    <tr>
                      <th class="transparent">
                        <div>KW</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Mo</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Di</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Mi</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Do</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Fr</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>Sa</div>
                      </th>
                      <th class="transparent" :class="compColor.primeClass">
                        <div>So</div>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in getPopupValues.dayArray" :key="index" class="transparent">
                      <td class="transparent">
                        <div>{{ row.kw }}</div>
                      </td>
                      <td v-for="(day, index2) in row.days" :key="index2"
                          v-bind:class="[
                          { 'blue-grey lighten-2 white--text caption': day.in && !day.active && !isDarkMode,
                          'blue-grey darken-1 white--text caption': day.in && !day.active && isDarkMode,
                          'blue-grey lighten-5 not-in caption': !day.in && !isDarkMode,
                          'transparent not-in caption': !day.in && isDarkMode
                          }, day.active ? compColor.prime + ' white--text font-weight-bold active body-2':'']">
                        <div @click="selectDay(day.value, day.month)" class="layout-column layout-align-center-center"
                             v-on:dblclick="applySelectedDate">{{ day.value }}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="layout-row">
                  <v-btn class="flex blue-grey elevation-0 pa-0"
                         :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                         @click="nextWeek(1)" style="height:auto;">
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-divider vertical class="mx-2" style="opacity: 0.5"></v-divider>

              <div class="layout-column">
                <div class="layout-row">
                  <v-btn class="flex blue-grey elevation-0 pa-0"
                         :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}" dense
                         @click="nextMonth(-1)" style="height:auto;">
                    <v-icon>mdi-chevron-up</v-icon>
                  </v-btn>
                </div>
                <div class="flex my-2 layout-column layout-align-center-start ">
                  <div class="linked" v-for="(item, index) in monthArray" :key="index" @click="selectMonth(index)"
                       v-bind:class="[index === getPopupValues.selectedMonth ? compColor.primeClass + ' font-weight-bold' : '',{ 'active': index === getPopupValues.selectedMonth }]">
                    <strong class="mr-1" style="font-weight:900;opacity: 0.25;">{{ index + 1 | leadingZero }}</strong>
                    <!--            <span style="opacity: 0.25;" class="ml-1 mr-1">|</span>-->
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="layout-row">
                  <v-btn class="flex blue-grey elevation-0 pa-0"
                         :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}" dense
                         @click="nextMonth(1)" style="height:auto;">
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-divider vertical class="mx-2" style="opacity: 0.5"></v-divider>

              <div class="layout-column" style="max-width: 58px;width: 58px;min-width: 58px;">

                <v-btn class="blue-grey elevation-0 pa-0"
                       :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                       @click="scrollList(-1)" style="height:auto;">
                  <v-icon>mdi-chevron-up</v-icon>
                </v-btn>

                <div class="flex layout-column my-2" style="overflow: hidden;position:relative;">
                  <div style="width:75px;height:100%;position: absolute;overflow-y:scroll;" id="yearList">
                    <div class="linked" style="text-align: center;min-width: 55px;" v-bind:id="'year-id-' + item"
                         v-for="(item, index) in yearArray" :key="index" @click="selectYear(item)"
                         v-bind:class="[index === getPopupValues.selectedYear - 1900 ? compColor.primeClass + ' font-weight-bold' : '',{ 'active': index === getPopupValues.selectedYear - 1900 }]">
                      <span>{{ item }}</span></div>
                  </div>
                </div>

                <v-btn class="blue-grey elevation-0 pa-0"
                       :class="{'lighten-5 blue-grey--text': !isDarkMode, 'darken-3 white--text': isDarkMode}"
                       @click="scrollList(1)" style="height:auto;">
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
            </div>

            <v-divider class="ma-0 mb-1"></v-divider>


            <div class="layout-row layout-align-end-center">
              <v-btn depressed color="blue-grey" height="30" :class="{'darken-3': isDarkMode}"
                     class="text-none flex ma-0 white--text" @click="applySelectedDate">Datum übernehmen
              </v-btn>
              <v-btn depressed color="blue-grey" height="30" :class="{'darken-3': isDarkMode}"
                     class="text-none ml-1 my-0 mr-0 px-2 white--text" @click.stop="dialog=false">
                <v-icon>cancel</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import gsap from 'gsap/dist/gsap'
import Draggable from 'gsap/dist/Draggable'
import lodash from 'lodash'

export default Vue.component('lxDatepicker', {
  /**
   * ##########################################################################################################
   * #  notwendig damit Kommunikation mit der Validierung vee-validate in der Parent Komponente funktioniert  #
   * ##########################################################################################################
   * */
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },
  data () {
    return {
      dialog: false,
      min: 1900, // kleinste mögliche Jahreszahl
      max: 2100, // größte mögliche Jahreszahl
      internalModel: '', // enthält das v-model des inputfeldes innerhalb des Datepickers
      dialogVisible: false,
      yearArray: [], // alle Jahre, die per Schleife von min bis max gefüllt werden
      monthArray: moment.months(), // alle Monate, übersetzt aus der moment.js DE Localisationsdatei
      dayArray: [], // Array, welches mit allen Tagen des aktuellen Monats und Jahres befüllt wird
      dateTimeToday: moment(), // die Variable dateTimeToday erhält den heutigen Tag als Wert, wird nicht mehr geändert
      internalValue: moment(), // interner Wert des Datepickers zum Start auf den heutigen Tag gesetzt, später den gewählten
      internalChange: false, // ob das Parent v-model aus dem Datepicker heraus geändert wurde 'true' oder von außen 'false'
      preventTriggerChangeWhenAutoFocus: false
    }
  },
  props: {
    value: [String, Date, Object], // der Typ den das v-model im Parent haben kann ist entweder ein Object, String oder Date
    name: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: { // bekommt die Errormessages übergeben
      type: [Array, String],
      required: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    required: {
      type: [Boolean]
    },
    dense: {
      type: [Boolean]
    },
    hint: {
      type: String
    },
    persistent_hint: {
      type: Boolean
    },
    keyValue: {
      type: String
    }
  },
  computed: {
    /**
     * wenn vee-validate in der Parentkomponente einen Fehler erkennt und damit this.error sich ändert dann werden
     * hier im Datepicker die Errormessages getriggert durch diese computed Property
     * */
    getErrorMsg: function () {
      if (!this.error) {
        return []
      }
      return this.error
    },
    /**
     * wenn das Popup sich öffnet, braucht es anhand des aktuell verwendeten Datum (v-model Wert oder heutiger Tag)
     * die richtigen Tage zum Anzeigen, also die des letzten Monats, des jetzigen und des Nächsten
     * mit welchen Wochentag der Monat beginnt etc. sowie die dazu passenden Kalenderwochen
     * dies alles wird in der computed Property getPopupValues als Objekt gespeichert
     * */
    getPopupValues: function () {
      let popupValues = {}
      let today = this.internalValue

      if (!moment(today).isValid() || !today || !today.get) {
        // today must be set to generate days of month in datepicker
        today = this.dateTimeToday
        // today = null
      }

      if (today) {
        popupValues.today = today
        popupValues.selectedYear = today.get('year')
        popupValues.selectedMonth = today.get('month')
        popupValues.selectedDay = today.get('date')
      }

      // Anzahl der Tage im letzten Monat
      let lastMonth = moment(today).date(0).date()

      // Versatz der Tage angenommen als Montag = 0 und Samstag = 6
      let engDate = moment(today).set('date', 1).day() - 1
      if (engDate < 0) {
        engDate += 7
      }

      // Anzahl der Tage des ausgewählten/aktuellen Monats
      let monthLength = moment(today).endOf('month').date()

      // Nummer der Kalenderwoche für die erste Woche des ausgewählten/aktuellen Monats
      let kalenderwoche = moment(today).isoWeek()

      let dayArray = []

      for (let i = 0; i < 6; i++) {
        let row = []
        for (let j = 0; j < 7; j++) {
          let val = (i * 7 + j) - engDate + 1
          let obj = {
            in: true,
            active: val === popupValues.selectedDay,
            value: val,
            month: 0
          }

          // Bereich um die letzten Felder der 6 x 7 Matrix mit den Daten des nächsten Monats auffüllen
          if (obj.value > monthLength) {
            obj.value = obj.value - monthLength
            obj.in = false
            obj.month = 1
          }

          // Bereich um die ersten Felder der 6 x 7 Matrix mit den Daten des vorherigen Monats auffüllen
          if (i === 0 && j < engDate) {
            obj.in = false
            obj.value = lastMonth + j - engDate + 1
            obj.month = -1
          }

          row.push(obj)
        }

        let kwObj = {
          kw: kalenderwoche + i,
          days: row
        }

        dayArray.push(kwObj)
      }

      // popupValues.dayArray = dayArray
      this.$set(popupValues, 'dayArray', dayArray)

      return popupValues
    }
  },
  created () {
    gsap.registerPlugin(Draggable)

    // das Jahresarray wird mit Jahreszahlen von min bis max gefüllt z.B.: 1900 bis 2100
    for (let i = 0; i < this.max - this.min + 1; i++) {
      this.yearArray.push(i + this.min)
    }
  },
  methods: {
    /**
     * Wird bei click auf den Button neben dem Datepicker Input aufgerufen, um das Popup damit zu öffnen.
     * Anschließend wird das aktuelle ausgewählte Jahr in die Mitte gescrollt, damit es sichtbar ist.
     * auch wenn kein Datum im v-model der Parent Komponente ist, gibt es im Popup einen Wert zum Anzeigen und
     * das ist das heutige Datum
     * */
    openDialog () {
      if (!this.disabled) {
        this.dialog = true
        setTimeout(() => {
          this.scrollYearIntoView()
          this.dragThatThing()
        }, 0)
      }
    },
    /**
     * Wird von vielen Methoden aufgerufen, um das aktuell ausgewählte Jahr im Popup in die Mitte zu scrollen
     * dies kann notwendig sein, da ein Datum in einem Jahr liegt, welches eventuell noch nicht sichtbar ist in der Liste
     * da nur maximal 9-10 Jahreszahlen gleichzeitig angezeigt werden können
     * */
    scrollYearIntoView () {
      if (this.dialog) {
        setTimeout(() => {
          let t = this.dateTimeToday.get('year')
          if (moment(this.internalValue).isValid()) {
            t = this.internalValue && this.internalValue.get ? this.internalValue.get('year') : new Date().getFullYear()
          }
          if (t >= this.min && t <= this.max) {
            let el = document.getElementById('year-id-' + (t - 5 >= this.min ? t - 5 : t))
            el.scrollIntoView()
          }
        }, 100)
      }
    },
    /**
     * wird aufgerufen, wenn man das Input Feld verlässt, da dabei der onBlur Event geworfen wird
     * der eingegebene String wird dabei überprüft, ob er einem validen Datum entspricht. Wenn dem so ist,
     * wird der momentjs Datumswert an das v-model der parent Komponente übergeben mittels $emit('input' ...)
     * nur so ist eine reactive Änderung möglich und das Partent Model bekommt die Änderung aktiv mit
     * */
    updateValue (e) {
      let dateValue = undefined
      let payload = undefined
      let formattedInputValue = moment(e.target.value)

      if (e.target) {
        dateValue = moment(e.target.value, 'DD.MM.YYYY')
        payload = e.target.value
      } else {
        dateValue = moment(e, 'DD.MM.YYYY')
        payload = e
      }

      this.internalChange = true

      if (dateValue.isValid()) {
        payload = dateValue
        this.internalValue = dateValue.hour(12).minutes(0).second(0).millisecond(0)
        this.$emit('input', payload)
      } else if (moment(formattedInputValue).isValid()) {
        payload = moment(formattedInputValue).hour(12).minutes(0).second(0).millisecond(0)
        this.internalValue = payload
        this.$emit('input', payload)
      } else {
        this.internalValue = this.dateTimeToday
        this.$emit('input', payload.toString().length > 0 ? payload : undefined)
      }
    },
    /**
     * wird bei click auf die Hoch-und-Runter-Buttons im Jahresbereich des Popups aufgerufen
     * die Richtung wird mit -1 oder 1 über die Variable direction übergeben
     * */
    scrollList (direction) {
      let el = document.getElementById('yearList')
      if (el) {
        el.scrollTop += (30 * direction)
      }
    },
    /**
     * Wird aufgerufen, wenn man das popup draggen möchte, dabei klickt man auf den Header des Popups
     * - es wird der Body aus dem HTML geholt über die ID 'app'
     * - dann die Größe des Fensters bestimmt mit getBoundingClientRect, da Body auf 100 % in beide Richtung stretcht
     * - dann wird Popup zu Draggable Obejct gemacht in den Grenzen des Body (bounds)
     * */
    dragThatThing () {
      Draggable.create('#square', {
        bounds: "#bodyTag",
        // throwProps: true,
        onDragStart: function () {
          this.target.style.opacity = 0.6
        },
        onDragEnd: function () {
          this.target.style.opacity = 1.0
        }
      })
    },
    /**
     * Wird aufgerufen wenn man beim popup draggen loslässt
     * - killt das Draggable Object
     * */
    leftThatThing () {
      Draggable.get('#square').kill()
    },
    /**
     * Wird bei Klick auf den heute Button im Popup aufgerufen
     * - dies setzt den Wert des internen Wertes this.internalValue auf den heutigen Tag
     * - dabei kann es zu einem Jahreswechsel kommen und damit zu einem neu ausgewählten Jahr,
     *   welches wieder in die Mitte gescrollt wird, damit es besser sichtbar ist,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    thisDay () {
      this.internalValue = moment(this.dateTimeToday)
      this.scrollYearIntoView()
    },
    /**
     * Wird bei Klick auf den morgen Button im Popup aufgerufen
     * - dies setzt den Wert des internen Wertes this.internalValue auf den morgigen tag
     * - dabei kann es zu einem Jahreswechsel kommen und damit zu einem neu ausgewählten Jahr,
     *   welches wieder in die Mitte gescrollt wird, damit es besser sichtbar ist,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    nextDay () {
      let date = this.internalValue

      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }

      this.internalValue = moment().add(1, 'day')
      this.scrollYearIntoView()
    },
    lastDay () {
      let date = this.internalValue

      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }

      this.internalValue = moment().add(-1, 'day')
      this.scrollYearIntoView()
    },
    /**
     * Wird bei Klick auf den Plus oder Minus Buttons für Wochen im Popup aufgerufen
     * - beim Klick auf Minus wird value = -1 übergeben,
     * - beim klick auf Plus wird value = 1 übergeben,
     * - dies setzt den Wochen-Wert des internen Wertes this.internalValue auf die nächste oder vorherige Woche
     * - dabei kann es zu einem Monatswechsel, damit verbunden einem Jahreswechsel kommen und damit
     *   zu einem neu ausgewählten Jahr, welches wieder in die Mitte gescrollt wird, damit es besser sichtbar ist,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    nextWeek (value) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).add(value, 'week')
      this.scrollYearIntoView()
    },
    /**
     * Wird bei Klick auf den Plus oder Minus Buttons für Monate im Popup aufgerufen
     * - beim klick auf Minus wird value = -1 übergeben,
     * - beim klick auf Plus wird value = 1 übergeben,
     * - dies setzt den Monats-Wert des internen Wertes this.internalValue auf den nächsten oder vorherigen Monat
     * - dabei kann es zu einem Jahreswechsel kommen und damit zu einem neuen ausgewählten Jahr,
     *   welches wieder in die Mitte gescrollt wird, damit es besser sichtbar ist,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    nextMonth (value) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).add(value, 'month')
      this.scrollYearIntoView()
    },
    /**
     * Wird bei Klick auf den Plus oder Minus Buttons für Jahre im Popup aufgerufen
     * - beim klick auf Minus wird value = -1 übergeben,
     * - beim klick auf Plus wird value = 1 übergeben,
     * - dies setzt den Jahres-Wert des internen Wertes this.internalValue auf das nächstes oder vorherige Jahr
     * - ausgewählte Jahre werden in die Mitte gescrollt damit sie besser sichtbar sind,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    nextYear (value) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).add(value, 'year')
      this.scrollYearIntoView()
    },
    /**
     * Wird bei Klick auf einen Tag im Popup aufgerufen
     * - setzt den Tages-Wert des internen Wertes this.internalValue auf den neuen Tag
     * - sollte der Tag im letzten Monat liegen wird Month = -1 und im nächsten Monat = +1
     * */
    selectDay (day, month) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).add(month, 'month').set('date', day)
    },
    /**
     * Wird bei Klick auf einen Monat im Popup aufgerufen
     * - setzt den Monats-Wert des internen Wertes this.internalValue auf den neuen Monat
     * */
    selectMonth (month) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).set('month', month)
    },
    /**
     * Wird bei Klick auf ein Jahr im Popup aufgerufen
     * - setzt den Jahres-Wert des internen Wertes this.internalValue auf das neue Jahr
     * - ausgewählte Jahre werden in die Mitte gescrollt, damit sie besser sichtbar sind,
     *   deshalb wird this.scrollYearIntoView() aufgerufen
     * */
    selectYear (year) {
      let date = this.internalValue
      if (!moment(date).isValid()) {
        date = lodash.clone(this.dateTimeToday, true)
      }
      this.internalValue = moment(date).set('year', year)
      this.scrollYearIntoView()
    },
    applySelectedDate () {
      this.internalChange = true
      this.internalModel = this.internalValue.format('DD.MM.YYYY')
      this.internalValue = moment(this.internalModel, 'DD.MM.YYYY')
      this.$emit('blur', this.internalValue)
      this.$emit('input', this.internalValue.hour(12).minutes(0).second(0).millisecond(0))
      this.dialog = false
    }
  },
  watch: {
    /**
     * Lauscht auf dem v-model des parents dieser Komponente, wenn also von außen über GetData oder ein Reset
     * das Datum geändert wird, allerdings ändert sich dieses v-model, auch wenn man im Datepicker das Datum übernimmt
     * und per $emit('input') dem v-model mitteilt
     *
     * verschiedene Kombinationen von neuem Wert zu altem Wert erfordern verschiedene Reaktionen:
     *
     * 1) der neue Value ist nicht definiert, und die boolean Variable this.internalchange ist true,
     *    das bedeutet der Wert wurde händisch im Datepickerinput herausgelöscht
     * 2) alle anderen Fälle in denen NICHT der neue Value vom Typ string ist und gleichzeitig
     *    der alte Value ein Object ist, schauen ob newValue ein valides Datum ist:
     *      - wenn ja, dann formatieren in DD.MM.YYYY und an input geben per internen v-model this.internalModel
     *      - wenn nicht, dann String direkt übergeben, führt aber zu Validierungsfehler da kein Datum
     *    in jedem der beiden Fälle wird aber das newValue an den interen Platzhalter this.internalValue übergeben
     * 3) alle anderen Kombinationen müssen nicht berücksichtigt werden
     * */
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === undefined && this.internalChange) {
            this.internalChange = false
            this.internalModel = ''
          } else {
            // check if newValue is defined, because of moment(undefined) is valid and same as new Date
            if (newValue && moment(newValue, ['DD.MM.YYYY', 'DD.MM.YY', moment.ISO_8601]).isValid()) {
              this.internalModel = moment(newValue).format('DD.MM.YYYY')
            } else {
              this.internalModel = newValue
            }

            this.internalValue = newValue instanceof moment || !moment(newValue, ['DD.MM.YYYY', 'DD.MM.YY', moment.ISO_8601]).isValid() ? newValue : moment(newValue, ['DD.MM.YYYY', 'DD.MM.YY', moment.ISO_8601])
          }
        }
      },
      immediate: true
    }
  }
})
</script>

<style scoped lang="scss">
.not-in {
  color: #8a8f9a;
}

div.teal--text.active {
  color: #4db6ac;

  span {
    font-weight: 700;
  }
}

td {
  cursor: pointer;
}

td.active {
  div {
    font-weight: 700;
  }
}

.linked {
  cursor: pointer;
  line-height: 19px;
  font-size: 15px;
  height: 19px;
}

.other-month {
  background: #ffcb52;
  opacity: 0.4;
  color: black;
  border: 1px solid #6d6d6d;
}

/*table {*/
/*border: 1px solid #222e3e2b;*/
/*}*/
table thead th {
  font-size: 14px;
  background: #e0e0e0;
  border-bottom: 1px solid #4cb6ac !important;

  &:first-child {
    padding-right: 10px;
    background: rgba(0, 150, 136, 0.13);
  }

  div {
    text-align: center;
    line-height: 30px;
    width: 30px;
    height: 30px;
  }
}

table tbody td {
  font-size: 14px;
  background: #ffe8f0;

  &:not(:first-child):hover {
    /*background:darken(#ccebe8, 10);*/
  }

  &:first-child {
    background: transparent;
    padding-right: 10px;
  }

  div {
    text-align: center;
    line-height: 30px;
    width: 30px;
    height: 30px;
  }
}

#square {
  max-width: 650px;
  width: 650px;
  min-width: 650px;
  min-height: 300px;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  margin-left: -275px;
  margin-top: -200px;
  box-shadow: 0 0 42px rgba(0, 0, 0, 0.7);
}

</style>
